// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {586: "recorder",621: "profiler",}[chunkId] + "-internal-48876777-1824-4d54-b109-e085a44863f0-" + {586: "32ff2ecf8faa0b5d",621: "b335cb7a2818d29f",}[chunkId] + ".js"
}